import { render, staticRenderFns } from "./DeleteNotifyDialog.vue?vue&type=template&id=142f5381&"
import script from "./DeleteNotifyDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteNotifyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports